<template>
  <article class="vch-card">
    <a
      tabindex="0"
      itemprop="contentUrl"
      class="vch-card__link"
      :href="`https://www.youtube.com/watch?v=${videoId}`"
      v-vch-video-popin="{ vid: videoId, transcript: transcript }"
    >
      <div class="vch-card__thumbnail vch-card__large">
        <div class="vch-card__video-decoration">
          <svg role="img" :aria-label="playVideoAriaLabel">
            <use href="/assets/sprite/icons.svg#element-play"></use>
          </svg>
        </div>
        <img
          class="vch-media-gallery__item-img-element lazyload"
          :alt="imageAlt"
          :src="image.src"
          :data-srcset="image.srcset"
          :data-sizes="imageSizes"
          itemprop="thumbnailUrl"
        />
      </div>
      <div class="vch-card__heading" itemprop="name">
        <h3 class="heading-md-em mb-xxs">{{ title }}</h3>
        <p class="vch-card__text text-body" itemprop="description">
          {{ description }}
        </p>
      </div>
    </a>
  </article>
</template>
<script>
export default {
  name: 'vch-card-video',
  props: {
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    videoId: {
      type: String,
      required: false,
    },
    transcript: {
      type: String,
      required: false,
    },
    image: {
      type: Object,
      required: false,
    },
    imageSizes: {
      type: String,
      default:
        '(min-width: 1600px) 368px, (min-width: 1280px) 288px, (min-width: 1024px) 234px, 50vw',
    },
    playVideoAriaLabel: {
      type: String,
      default: 'video',
    },
  },
  computed: {
    imageAlt() {
      return this.image?.altText || '';
    },
  },
};
</script>
